import { render, staticRenderFns } from "./index.vue?vue&type=template&id=d3f32316&scoped=true"
var script = {}
import style0 from "./index.vue?vue&type=style&index=0&id=d3f32316&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3f32316",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\mydata\\code\\local.lzj\\sportman\\admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d3f32316')) {
      api.createRecord('d3f32316', component.options)
    } else {
      api.reload('d3f32316', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=d3f32316&scoped=true", function () {
      api.rerender('d3f32316', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/index/components/d2-page-cover/index.vue"
export default component.exports